import React from 'react';
import { Title, Meta, Link } from 'react-head';

const SEO = ({ 
  title = 'GlobeTune - World Radio Stations',
  description = 'Listen to radio stations from around the world. Discover local and international radio stations, music, news, and entertainment in one place.',
  keywords = 'radio, online radio, internet radio, music streaming, global radio, radio stations, live radio',
  canonicalUrl,
  ogType = 'website',
  ogImage = '/Logo.png'
}) => {
  const siteUrl = 'https://globetune.co.uk'; // Replace with your actual domain
  const fullCanonicalUrl = canonicalUrl ? `${siteUrl}${canonicalUrl}` : siteUrl;
  
  return (
    <>
      {/* Basic Meta Tags */}
      <Title>{title}</Title>
      <Meta name="description" content={description} />
      <Meta name="keywords" content={keywords} />
      
      {/* Canonical URL */}
      <Link rel="canonical" href={fullCanonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <Meta property="og:type" content={ogType} />
      <Meta property="og:url" content={fullCanonicalUrl} />
      <Meta property="og:title" content={title} />
      <Meta property="og:description" content={description} />
      <Meta property="og:image" content={`${siteUrl}${ogImage}`} />
      
      {/* Twitter */}
      <Meta name="twitter:card" content="summary_large_image" />
      <Meta name="twitter:url" content={fullCanonicalUrl} />
      <Meta name="twitter:title" content={title} />
      <Meta name="twitter:description" content={description} />
      <Meta name="twitter:image" content={`${siteUrl}${ogImage}`} />
    </>
  );
};

export default SEO; 